import { Component, OnInit, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { collection, doc, getDocs, orderBy, query, where } from 'firebase/firestore';
import { User, History } from 'src/app/interfaces';
import { db } from 'src/app/app.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';

export interface DialogData {
  user: User;
}

@Component({
  selector: 'app-credits-history',
  templateUrl: './credits-history.component.html',
  styleUrls: ['./credits-history.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, DatePipe],
})
export class CreditsHistoryComponent implements OnInit {
  loading = signal(true);
  organisationId: string = localStorage.getItem('orgId');
  history = signal<History[]>([]);

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  async ngOnInit() {
    console.log(doc(db, `users/${this.data.user.id}`));
    const chargeDocs = await getDocs(
      query(
        collection(db, `organisations/${this.organisationId}/charges`),
        where('userRef', '==', doc(db, `users/${this.data.user.id}`)),
        orderBy('date', 'desc'),
      ),
    );
    chargeDocs.forEach((charge) => {
      this.history.update((h) => [...h, { ...charge.data(), id: charge.id } as History]);
    });

    const paymentDocs = await getDocs(
      query(
        collection(db, `organisations/${this.organisationId}/payments`),
        where('userRef', '==', doc(db, `users/${this.data.user.id}`)),
        orderBy('date', 'desc'),
      ),
    );
    paymentDocs.forEach((charge) => {
      this.history.update((h) => [...h, { ...charge.data(), id: charge.id } as History]);
    });

    this.history.set(
      this.history().sort((itemA, itemB) => {
        return itemB.date.toDate() - itemA.date.toDate();
      }),
    );

    this.loading.set(false);
  }
}
